import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsHttpClient } from '@cms_root/app/api-clients/cms/cms-http-client.service';
import { environment } from '@cms_root/environments/environment';
import { LoginResponse } from '../../base/models/login-response.model';
import { AuthBaseApi } from '../../base/services/auth-base-api';

@Injectable({
  providedIn: 'root'
})
export class CmsAuthApiService implements AuthBaseApi {
  private readonly loginUrl = `${environment.cmsApi}waauth/login`;

  constructor(private readonly httpClient: CmsHttpClient) {}

  login(authSessionId: string): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(
      this.loginUrl,
      { authSessionId },
      {
        withCredentials: true
      }
    );
  }
}
